export const MAIN_CLASS_NAME = 'settings';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const SCROLL_CLASS_NAME = `${CONTENT_CLASS_NAME}__scroll`;
export const BLOCK_CLASS_NAME = `${SCROLL_CLASS_NAME}__block`;
export const BLOCK_TITLE_CLASS_NAME = `${BLOCK_CLASS_NAME}__title`;
export const BLOCK_ITEM_CLASS_NAME = `${BLOCK_CLASS_NAME}__item`;
export const BLOCK_ROW_CLASS_NAME = `${BLOCK_CLASS_NAME}__row`;
export const BLOCK_ROW_ITEM_CLASS_NAME = `${BLOCK_ROW_CLASS_NAME}__item`;
export const SWITCH_DESCRIPTION_CLASS_NAME = `${BLOCK_ITEM_CLASS_NAME}__switch-description`;
export const FOOTER_CLASS_NAME = `${MAIN_CLASS_NAME}__footer`;
export const SCHEMA_MODAL_CLASS_NAME = `${MAIN_CLASS_NAME}__schema-modal`;
export const SCHEMA_FRAME_CLASS_NAME = `${MAIN_CLASS_NAME}__schema-frame`;
export const SCHEMA_FRAME_LOADING_CLASS_NAME = `${SCHEMA_FRAME_CLASS_NAME}_loading`;
export const SCHEMA_FRAME_SPIN_CLASS_NAME = `${SCHEMA_FRAME_CLASS_NAME}__spin`;
export const ELMA365_TOOL_MAIN_SETTINGS_CLASS_NAME = `${CONTENT_CLASS_NAME}_elma365-tool-main`;
export const ELMA365_TOOL_JSON_SCHEMA_SETTINGS_CLASS_NAME = `${CONTENT_CLASS_NAME}_elma365-tool-json-schema`;
export const CHECKBOX_CLASS_NAME = `${BLOCK_ITEM_CLASS_NAME}__checkbox`;
export const TOOL_CALL_OUTPUT_MAX_SIZE_CLASS_NAME = `${BLOCK_ITEM_CLASS_NAME}__tool-call-output-max-size`;
export const HTTP_HEADERS_CLASS_NAME = `${BLOCK_ITEM_CLASS_NAME}__http-headers`;
